import React from 'react';
import { Button, Alert, Popover, Modal, ModalHeader, ModalFooter, ModalBody, Row, Col, FormGroup, Input, Label, Progress, InputGroup, UncontrolledTooltip } from 'reactstrap';
import $ from 'jquery';
import { withAlert } from 'react-alert';
import { connect } from 'react-redux'
import ValidatedTextBox from '../ValidatedTextBox';
import { Flag } from 'flagger/react';
import { CircularProgress } from '@mui/material';;

class NewPollingServiceModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: '',
      service: {},
      documentTypes: [],
      folders: [],
      pollerType: '',
      isLoading: false,
      folder: '',
      submitted: false
    }
  }

  componentDidMount = () => {
    this.getX3Folders();
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.state.folder != prevState.folder) {
      this.setState({
        documentTypes: []
      })
      this.getDocumentTypes();
    }
  }

  isFormValid = () => {
    const { service, pollerType } = this.state;
    if (!service.name) return false;
    if (!service.description) return false;
    if (!service.folder) return false;
    if (!service.documentType) return false;
    if (!pollerType) return false;
    if (pollerType === 'mailbox') {
      if (!service.protocol) return false;
      if (!service.host) return false;
      if (!service.port) return false;
      if (!service.attachmentLocation) return false;
      if (!service.username) return false;
    }
    if (pollerType === 'directory') {
      if (!service.directory) return false;
    }
    return true;
  }

  savePollerService = () => {
    this.setState({ submitted: true });
    if (!this.isFormValid()) return;
    try {
      this.setState({
        isLoading: true
      });
      fetch('/api/poller/add_polling_process', {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ service: this.state.service })
      })
        .then(res => res.json())
        .then(result => {
          this.setState({
            isLoading: false
          });

          if (result.error) {
            this.setState({
              errorMessage: result.error
            })
          } else {
            this.props.addCompleted();
          }
        })
    } catch (err) {
      this.setState({
        errorMessage: err.message,
        isLoading: true
      });
    }
  }

  handleTextChange = (valid, e) => {
    const target = e.target;
    const value = target.value;
    const name = target.id;
    let service = { ...this.state.service };
    service[name] = value;

    this.setState({
      service
    });
  }

  handlePasswordChange = (e) => {
    const target = e.target;
    const value = target.value;
    const name = target.name;
    let service = { ...this.state.service };
    service[name] = value;

    this.setState({
      service
    });
  }

  handleDropDownChange = (e) => {
    const target = e.target;
    const value = target.value;
    const name = target.name;
    let service = { ...this.state.service };
    service[name] = value;

    this.setState({
      service,
      folder: value
    });
  }

  handleDocTypeDropDownChange = (e) => {
    const target = e.target;
    const value = target.value;
    const name = target.name;
    let service = { ...this.state.service };
    service[name] = value;

    this.setState({
      service
    });
  }


  handleTypeDropDownChange = (e) => {
    const target = e.target;
    const value = target.value;
    let service = { ...this.state.service };
    service.type = value;

    this.setState({
      service,
      pollerType: value
    });
  }

  handleCheckChange = (e) => {
    const target = e.target;
    const value = target.checked;
    const name = target.name;
    let service = { ...this.state.service };
    service[name] = value;

    this.setState({
      service
    });
  }

  getDocumentTypes = () => {
    fetch('/api/configuration/documentTypes?folder=' + this.state.service.folder)
      .then(res => res.json())
      .then(result => {
        this.setState({
          documentTypes: result
        })
      })
  }

  getX3Folders = async () => {
    try {
      const r = await fetch(`${window.location.origin}/api/sageX3/get_x3_folders`, {
        headers: { "Accept": "application/json" }
      });

      const payload = await r.json();

      if (!r.ok) {
        console.error("get_X3_folders failed", payload);
        this.setState({ isLoading: false });
        return;
      }

      this.setState({
        folders: payload?.folders ?? [],
        isLoading: false
      });
    } catch (err) {
      console.error("get_X3_folders error", err);
      this.setState({ isLoading: false });
    }
  };

  render() {
    const { localisation } = this.props.userReducer;
    const { submitted, service, pollerType } = this.state;
    let alert_message = <div />
    let doc_types = [];
    let folders = [];

    const reqLabel = (text) => (
      <span>{text} <span style={{ color: 'red' }}>*</span></span>
    );
    const dropdownInvalid = (value) => submitted && !value;
    const invalidStyle = { borderColor: '#eb2329' };
    const feedbackStyle = { color: '#eb2329', fontSize: '14px', display: 'block' };


    if (this.state.errorMessage)
      alert_message = <Alert color="danger">
        {this.state.errorMessage}
      </Alert>

    this.state.documentTypes.forEach(docType => {
      doc_types.push(<option value={docType.DocumentType}>{docType.Description.en}</option>)
    });

    this.state.folders.forEach(res => {
      folders.push(<option>{res.DOSSIER}</option>)
    });

    return (
      <Modal isOpen={this.props.visible} toggle={this.props.toggle} className='modal-dialog'>
        <ModalHeader toggle={this.props.toggle}>{localisation['new_polling_sesrvice_header'] ? localisation['new_polling_sesrvice_header'].element_lang : 'New Polling Service'}</ModalHeader>
        <ModalBody>
          <FormGroup>
            <ValidatedTextBox
              isEnabled={true}
              id="name"
              labelText={reqLabel(localisation['poller_name_text'] ? localisation['poller_name_text'].element_lang : 'Name')}
              onChange={this.handleTextChange}
              mandatory={true}
              submitted={submitted}
            />
          </FormGroup>
          <FormGroup>
            <ValidatedTextBox
              isEnabled={true}
              id="description"
              labelText={reqLabel(localisation['table_header_desc'] ? localisation['table_header_desc'].element_lang : 'Description')}
              onChange={this.handleTextChange}
              mandatory={true}
              submitted={submitted}
            />
          </FormGroup>
          <FormGroup>
            <Label for="folder" className="s-field-title s-anchored">{reqLabel(localisation['table_header_folder'] ? localisation['table_header_folder'].element_lang : 'Sage X3 Folder')}</Label>
            <Input type="select" name={"folder"} value={this.state.service.folder} onChange={this.handleDropDownChange} id={"folder"} style={dropdownInvalid(service.folder) ? invalidStyle : {}}>
              <option value="">{localisation['default_select_text'] ? localisation['default_select_text'].element_lang : 'Select ...'}</option>
              {folders}
            </Input>
            {dropdownInvalid(service.folder) && <span style={feedbackStyle}>Please select a Sage X3 Folder</span>}
          </FormGroup>
          <FormGroup>
            <Label for="documentType" id="lblDocType" className="s-field-title s-anchored">{reqLabel(localisation['document_type_text'] ? localisation['document_type_text'].element_lang : 'Document Type')}</Label>
            <UncontrolledTooltip placement="right" target="lblDocType">Default document type for documents which don't contain tags.</UncontrolledTooltip>
            <Input type="select" name={"documentType"} onChange={this.handleDocTypeDropDownChange} style={dropdownInvalid(service.documentType) ? invalidStyle : {}}>
              <option value="">{localisation['default_select_text'] ? localisation['default_select_text'].element_lang : 'Select ...'}</option>
              {doc_types}
            </Input>
            {dropdownInvalid(service.documentType) && <span style={feedbackStyle}>Please select a Document Type</span>}
          </FormGroup>
          <FormGroup>
            <Label for="type" className="s-field-title s-anchored">{reqLabel(localisation['type_text'] ? localisation['type_text'].element_lang : 'Poller Type')}</Label>
            <Input type="select" name={"type"} onChange={this.handleTypeDropDownChange} style={dropdownInvalid(pollerType) ? invalidStyle : {}}>
              <option value="">{localisation['default_select_text'] ? localisation['default_select_text'].element_lang : 'Select ...'}</option>
              <option value={"mailbox"}>Mailbox</option>
              <option value={"directory"}>Directory</option>
            </Input>
            {dropdownInvalid(pollerType) && <span style={feedbackStyle}>Please select a Poller Type</span>}
          </FormGroup>
          {this.state.pollerType == 'mailbox' &&
            <>
              <FormGroup>
                <Label for="protocol" className="s-field-title s-anchored">{reqLabel(localisation['protocol_text'] ? localisation['protocol_text'].element_lang : 'Protocol')}</Label>
                <Input type="select" name={"protocol"} onChange={this.handleDropDownChange} style={dropdownInvalid(service.protocol) ? invalidStyle : {}}>
                  <option value="">{localisation['default_select_text'] ? localisation['default_select_text'].element_lang : 'Select ...'}</option>
                  <option value={"imap"}>IMAP</option>
                  <option value={"Exchange"}>Exchange</option>
                  <option value={"pop3"}>POP3</option>
                </Input>
                {dropdownInvalid(service.protocol) && <span style={feedbackStyle}>Please select a Protocol</span>}
              </FormGroup>
              <FormGroup>
                <ValidatedTextBox
                  isEnabled={true}
                  id="host"
                  labelText={reqLabel(localisation['table_header_host'] ? localisation['table_header_host'].element_lang : 'Host Address')}
                  onChange={this.handleTextChange}
                  mandatory={true}
                  submitted={submitted}
                />
              </FormGroup>
              <FormGroup>
                <ValidatedTextBox
                  isEnabled={true}
                  id="port"
                  labelText={reqLabel(localisation['table_header_port'] ? localisation['table_header_port'].element_lang : 'Port Number')}
                  onChange={this.handleTextChange}
                  mandatory={true}
                  submitted={submitted}
                />
              </FormGroup>
              <FormGroup>
                <ValidatedTextBox
                  isEnabled={true}
                  id="attachmentLocation"
                  labelText={reqLabel(localisation['table_header_attachment_location'] ? localisation['table_header_attachment_location'].element_lang : 'Attachment Location')}
                  onChange={this.handleTextChange}
                  mandatory={true}
                  submitted={submitted}
                />
              </FormGroup>
              <FormGroup>
                <ValidatedTextBox
                  isEnabled={true}
                  id="username"
                  labelText={reqLabel(localisation['table_header_username'] ? localisation['table_header_username'].element_lang : 'username')}
                  onChange={this.handleTextChange}
                  mandatory={true}
                  submitted={submitted}
                />
              </FormGroup>
              <FormGroup>
                <Label for={"password"}>{"Password"}</Label>
                <Input type="password" name={"password"} autoComplete="false" onChange={this.handlePasswordChange} />
              </FormGroup>
              <FormGroup check style={{ marginTop: '0px' }}>
                <Label for="field_description" className="s-field-title s-anchored">
                  <Input type="checkbox" name={'ignoreTLS'} onClick={this.handleCheckChange} />{' '}
                  Ignore TLS
                </Label>
              </FormGroup>
              <FormGroup check style={{ marginTop: '0px' }}>
                <Label for="field_description" className="s-field-title s-anchored">
                  <Input type="checkbox" name={'useSSL'} onClick={this.handleCheckChange} />{' '}
                  Use SSL
                </Label>
              </FormGroup>
            </>
          }
          {this.state.pollerType == 'directory' &&
            <FormGroup>
              <ValidatedTextBox
                isEnabled={true}
                id="directory"
                labelText={reqLabel(localisation['table_header_directory'] ? localisation['table_header_directory'].element_lang : 'Directory Location')}
                onChange={this.handleTextChange}
                mandatory={true}
                submitted={submitted}
              />
            </FormGroup>
          }

          <FormGroup check style={{ marginTop: '0px' }}>
            <Label check className="s-field-title s-anchored">
              <Input type="checkbox" onChange={this.handleCheckChange} name={'startPoller'} />{' '}
              Start poller immediately
            </Label>
          </FormGroup>
          <FormGroup check style={{ marginTop: '0px' }}>
            <Label check className="s-field-title s-anchored">
              <Input type="checkbox" onChange={this.handleCheckChange} name={'documentWithTags'} />{' '}
              Document includes tags
            </Label>
          </FormGroup>
          <br />
          {alert_message}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.savePollerService}>
            {this.state.isLoading ?
              <CircularProgress style={{ width: '1.2rem', height: '1.2rem', borderWidth: '.1em' }} />
              :
              localisation['save_button'] ? localisation['save_button'].element_lang : ''}
          </Button>
          <Button color="secondary" onClick={this.props.toggle}>{localisation['cancel_button'] ? localisation['cancel_button'].element_lang : ''}</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default connect(state => state)(withAlert()(NewPollingServiceModal));